import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {ToursListFiltersProvider} from './core/ToursListFiltersProvider'
import {ToursTable} from './table/ToursTable'
import {TourEditModal} from './tour-edit-modal/TourEditModal'
import {KTCard} from '../../../../_dashboard/helpers'
import {ToursListHeader} from './header/ToursListHeader'

const ToursList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
        <ToursListHeader />
        <ToursTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <TourEditModal />}
    </>
  )
}

const ToursListWrapper = () => (
  <QueryRequestProvider>
    <ToursListFiltersProvider>
      <QueryResponseProvider>
        <ListViewProvider>
          <ToursList />
        </ListViewProvider>
      </QueryResponseProvider>
    </ToursListFiltersProvider>
  </QueryRequestProvider>
)

export {ToursListWrapper}
